import React, {  useState, useEffect } from "react";

export default function CODINGdECODINGtest(props) {
  const correctAnswers = [3, 0, 0, 0, 3, 3, 2, 1, 3, 1, 1, 2, 0, 1, 0, 1, 3, 1, 0, 3, 2, 0, 0, 2, 1];
  const que = {
    q1: {
      string: "1. If in a certain language, 'APPLE' is coded as 'EPPAL', how is 'MANGO' coded in that language?",
      options: ["GOMAN", "ONMAG", "NOGMA", "OGNAM"],
      ans: 3
    },
    q2: {
      string: "2. In a certain code language, 'HELLO' is written as 'OLLEH'. How is 'WORLD' written in that code?",
      options: ["DLROW", "DLOWR", "DRWOL", "WDRLO"],
      ans: 0
    },
    q3: {
      string: "3. If 'CAT' is coded as 'DBU', how is 'DOG' coded in that language?",
      options: ["EPH", "DOP", "EOH", "EPI"],
      ans: 0
    },
    q4: {
      string: "4. In a certain code, 'SNAKE' is written as 'EPKNS'. How would 'LEMON' be written in the same code?",
      options: ["ONMLE", "NOMLE", "NOMEL", "ONLME"],
      ans: 0
    },
    q5: {
      string: "5. If 'SCHOOL' is written as 'LOOHCS', how would 'COLLEGE' be written in the same code?",
      options: ["EGLOLC", "EGOLEC", "ELOLCG", "EGELLOC"],
      ans: 3
    },
    q6: {
      string: "6. If 'TABLE' is coded as 'LFUBM', how is 'CHAIR' coded?",
      options: ["SIBHC", "SDIBC", "SDBIC", "SHBIC"],
      ans: 3
    },
    q7: {
      string: "7. In a certain language, 'ZEBRA' is coded as 'EZBRZ'. How is 'LION' coded?",
      options: ["NOIL", "INLO", "OILN", "LNIO"],
      ans: 2
    },
    q8: {
      string: "8. If 'PAPER' is coded as 'REPPP', how is 'PENCIL' coded?",
      options: ["LCINPE", "LINCPE", "LICNPE", "LINPCE"],
      ans: 1
    },
    q9: {
      string: "9. In a certain code, 'COMPUTER' is written as 'CMOPETUR'. How is 'LAPTOP' written in that code?",
      options: ["LTAOPP", "LTAOPP", "LTPAOP", "LTAPOP"],
      ans: 3
    },
    q10: {
      string: "10. If 'TEACHER' is written as 'REHCAET', how would 'STUDENT' be written in the same code?",
      options: ["TUDENTS", "TNEDUTS", "TDNETSU", "TNEUTDS"],
      ans: 1
    },
    q11: {
      string: "11. In a certain language, 'HONEY' is coded as 'HONYE'. How is 'WATER' coded in that language?",
      options: ["WATER", "WTAER", "WATER", "WATER"],
      ans: 1
    },
    q12: {
      string: "12. If 'KING' is coded as 'IKGN', how is 'QUEEN' coded in that language?",
      options: ["UQNEE", "EUQEN", "EQNUE", "EQENU"],
      ans: 2
    },
    q13: {
      string: "13. In a certain code, 'DOOR' is written as 'OODR'. How is 'WINDOW' written in that code?",
      options: ["NIDWOW", "WINDOW", "WONDWI", "NDOWWI"],
      ans: 0
    },
    q14: {
      string: "14. If 'SMART' is written as 'RTAMS', how would 'PHONE' be written in the same code?",
      options: ["ONHEP", "EHONP", "ENHOP", "OHENP"],
      ans: 1
    },
    q15: {
      string: "15. If 'HOUSE' is coded as 'SUOEH', how is 'GARDEN' coded?",
      options: ["RDENGA", "NERDGA", "ERDGAN", "DREANG"],
      ans: 0
    },
    q16: {
      string: "16. In a certain language, 'PLAN' is coded as 'LNPA'. How is 'TREE' coded?",
      options: ["REET", "EERT", "ERET", "ERTE"],
      ans: 1
    },
    q17: {
      string: "17. If 'RIVER' is written as 'VRIER', how is 'BRIDGE' written?",
      options: ["IGRDEB", "GIRDEB", "GIEDRB", "GIDREB"],
      ans: 3
    },
    q18: {
      string: "18. In a certain code, 'APPLE' is written as 'EPPAL'. How is 'BANANA' written in that code?",
      options: ["ANABAN", "AANNBA", "NAAABN", "ANNAAB"],
      ans: 1
    },
    q19: {
      string: "19. If 'CODE' is written as 'OCED', how is 'DECODE' written?",
      options: ["EDOCE", "EDOCE", "DOCEED", "EDOCEC"],
      ans: 0
    },
    q20: {
      string: "20. If 'HEART' is written as 'REAHT', how would 'EARTH' be written in the same code?",
      options: ["HRETA", "ERTHA", "HTEAR", "RETHA"],
      ans: 3
    },
    q21: {
      string: "21. In a certain language, 'ORANGE' is coded as 'RONAGE'. How is 'MANGO' coded in that language?",
      options: ["NAMGO", "GNOMA", "NGOMA", "NAGMO"],
      ans: 2
    },
    q22: {
      string: "22. If 'SCHOOL' is written as 'LOOHCS', how would 'COLLEGE' be written in the same code?",
      options: ["EGOLEC", "ELOLCG", "EOLGCE", "ELOGCE"],
      ans: 0
    },
    q23: {
      string: "23. In a certain code, 'TRAIN' is written as 'NIRAT'. How is 'PLANE' written in that code?",
      options: ["ENALP", "EANLP", "LNEAP", "ENPLA"],
      ans: 0
    },
    q24: {
      string: "24. If 'HOUSE' is written as 'UHOES', how would 'MOUSE' be written in the same code?",
      options: ["ESUMO", "MSUOE", "SUOEM", "ESUOM"],
      ans: 2
    },
    q25: {
      string: "25. If 'WATER' is coded as 'ETWAR', how is 'FIRE' coded in that language?",
      options: ["REIF", "EFRI", "RIEF", "IRFE"],
      ans: 1
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>APTITUDE <span>CODING-DECODING</span></h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
